// extracted by mini-css-extract-plugin
export default {"container":"Error_container__P2Qgb"};